module.exports = __webpack_public_path__ + "media/assets/images/shopping/grade-3af618f58c2baf53980cc8a67ca80b6f.svg";